import {AfterViewInit, Component, OnInit} from '@angular/core';
// import {MenuItem, PrimeIcons} from 'primeng/api';
import {KeycloakService} from 'keycloak-angular';
import {Apollo} from 'apollo-angular';
import {gql} from '@apollo/client/core';
import {NavigationEnd, Route, Router, Event, RouterEvent} from '@angular/router';
import {KeycloakUser} from './model/model';
import {NgxPermissionsService} from 'ngx-permissions';
import {MenuItem} from 'primeng/api';
import {PayslipCollectionSegment, Query} from "../service/graphql";


const checkRegistered = gql`
  query {
    isRegistered
  }`;

const CLIENT_ACCESS_QUERY = gql`
  query ($entityID: UUID){
    clientModules (
      where: {
        CLIENT: {
          CLIENT_BILLINGS: {
            some: {
              ENTITY_CLIENT_BILLINGS: {
                some: {
                  ENTITY_ID: {
                    eq: $entityID
                  }
                }
              }
            }
          }
        }
      }
    ) {
      CLIENT {
        CLIENT_BILLINGS {
          ENTITY_CLIENT_BILLINGS {
            ENTITY_ID
          }
        }
      }
      HR_MODULE {
        MODULE_NAME
        MODULE_ID
      }
    }
  }
`;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'Financia';
  items: MenuItem[] = [];
  appUser: KeycloakUser | undefined;
  isUserLoggedIn = false;
  sidebarState = false;
  currentRoute: string;

  constructor(private keycloakService: KeycloakService,
              private router: Router,
              private permissionService: NgxPermissionsService,
              private apollo: Apollo,) {

    this.currentRoute = "";
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd)
      {
        this.currentRoute = event.url;
      }
    });
    
    this.keycloakService.isLoggedIn().then(async (x) => {
      this.isUserLoggedIn = x;
      // if (this.isUserLoggedIn) {
      //   this.keycloakService.getKeycloakInstance().loadUserInfo().then(async r => {
      //     const m: any = r;
      //     this.permissionService.loadPermissions(m.Roles);
      // this.permissionService.loadPermissions(this.keycloakService.getUserRoles(true));

      console.log('permissions boi', this.permissionService.getPermissions());
      this.items = [
        ...this.items,
        {
          label : 'Accomplishments',
          visible: await this.permissionService.hasPermission(['ADMINISTRATOR']),
          items : [
            {
              label: 'Report',
              routerLink: ['accomplishment/reports'],
              icon: 'fa-duotone fa-bar-chart',
              visible: true
            }
          ]
        },
        {
          label: 'Members',
          visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'ROSTER.ADMIN', 'ROSTER.WRITE', 'ROSTER.READ', 'APPLICANT.ADMIN', 'APPLICANT.WRITE', 'APPLICANT.READ', 'SHIFT.ADMIN', 'SHIFT.WRITE', 'SHIFT.READ']),
          items: [
            {
              label: 'Add a Member',
              routerLink: ['registration'],
              icon: 'fa-solid fa-plus',
              visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'ROSTER.ADMIN', 'ROSTER.WRITE', 'ROSTER.READ'])
            },
            {
              label: 'Roster',
              routerLink: ['member/roster'],
              icon: 'fa-duotone fa-person',
              visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'ROSTER.ADMIN', 'ROSTER.WRITE', 'ROSTER.READ'])
            },
            {
              label: 'Applicants',
              routerLink: ['member/applicants'],
              icon: 'fa-duotone fa-person-walking',
              visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'APPLICANT.ADMIN', 'APPLICANT.WRITE', 'APPLICANT.READ'])
            },
            {
              label: 'Deductions',
              routerLink: ['member/deductions-overview'],
              icon: 'fa-duotone fa-file-spreadsheet',
              visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'DEDUCTION.ADMIN', 'DEDUCTION.WRITE', 'DEDUCTION.READ'])
            },
            {
              label: 'Disbursements',
              routerLink: ['member/disbursement-overview'],
              icon: 'fa-duotone fa-file-spreadsheet',
              visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'DISBURSEMENT.ADMIN', 'DISBURSEMENT.WRITE', 'DISBURSEMENT.READ'])
            },
            {
              label: 'Shift Scheduler',
              routerLink: ['member/shiftscheduler'],
              icon: 'fa-duotone fa-calendar-range',
              visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'SHIFT.ADMIN', 'SHIFT.WRITE', 'SHIFT.READ'])
            },
            {
              label: 'Attachments',
              routerLink: ['member/attachments'],
              icon: 'fa-duotone fa-paperclip',
              visible: true
              // visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'SHIFT.ADMIN', 'SHIFT.WRITE', 'SHIFT.READ'])
            },
            {
              label: 'Concerns',
              routerLink: ['/admin/concerns'],
              icon: 'fa-duotone fa-person-walking',
              visible: await this.permissionService.hasPermission(['ADMINISTRATOR'])
            },
            {
              label: 'Leaves',
              routerLink: ['/admin/leaves'],
              icon: 'fa-duotone fa-person-walking',
              visible: await this.permissionService.hasPermission(['ADMINISTRATOR'])
            },
          ]
        },
        {
          label : 'Jobs',
          visible: await this.permissionService.hasPermission(['ADMINISTRATOR']),
          items : [
            {
              label: 'Job Opening',
              routerLink: ['job/opening'],
              icon: 'fa-duotone fa-briefcase',
              visible: true
            }
          ]
        },
        {
          label: 'Topsheets',
          visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'TOPSHEET.ADMIN', 'TOPSHEET.WRITE', 'TOPSHEET.READ']),
          items: [
            {
              label: 'Overview',
              routerLink: ['topsheet/overview'],
              icon: 'fa-duotone fa-file-spreadsheet',
              visible: true
            },
            {
              label: 'Create',
              routerLink: ['topsheet/create'],
              visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'TOPSHEET.ADMIN', 'TOPSHEET.WRITE']),
              icon: 'fa-duotone fa-file-plus'
            },
            {
              label: 'Rates',
              routerLink: ['topsheet/rate'],
              icon: 'fa-duotone fa-list-ol',
              visible: true
            },
            {
              label: 'NFC Report',
              visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'NFC.WRITE', 'NFC.ADMIN', 'NFC.READ']),
              routerLink: ['topsheet/nfc-report'],
              icon: 'fa-duotone fa-nfc-pen'
              // routerLink: ['payout/create']
            },
            {
              label: 'Payslips',
              visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'SOMA.WRITE', 'SOMA.ADMIN', 'SOMA.READ']),
              routerLink: ['topsheet/view-soma'],
              icon: 'fa-duotone fa-file-invoice-dollar'
              // routerLink: ['payout/create']
            },
          ]
        },
        {
          label: 'Payout',
          visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'PAYOUT.ADMIN', 'PAYOUT.WRITE', 'PAYOUT.READ']),
          items: [
            {
              label: 'Overview',
              routerLink: ['payout/overview'],
              icon: 'fa-duotone fa-file-user',
              visible: true
            },
            {
              label: 'Create',
              routerLink: ['payout/create'],
              visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'PAYOUT.ADMIN', 'PAYOUT.WRITE']),
              icon: 'fa-duotone fa-file-plus'
            }
          ]
          // routerLink: ['payout/create']
        },
        {
          label: 'Branches',
          visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'CLIENT.ADMIN', 'CLIENT.WRITE', 'CLIENT.READ']),
          // routerLink: ['client/overview'],
          items: [
            {
              label: 'Branches',
              routerLink: ['client/overview'],
              icon: 'fa-duotone fa-sitemap',
              visible: true
            },
            {
              label: 'Organizations',
              routerLink: ['client/organizations'],
              icon: 'fa-duotone fa-sitemap',
              visible: true
            }
          ]
        },
        {
          label: 'Billing',
          visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'BILLING.ADMIN', 'BILLING.WRITE', 'BILLING.READ']),
          items: [
            {
              label: 'Overview',
              routerLink: ['billing/overview'],
              icon: 'fa-duotone fa-money-bill-simple-wave',
              visible: true
            },
            {
              label: 'Create',
              routerLink: ['billing/create'],
              icon: 'fa-duotone fa-file-plus',
              visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'BILLING.WRITE', 'BILLING.ADMIN']),
            },
            {
              label: 'SOA',
              routerLink: ['billing/soa'],
              icon: 'fa-duotone fa-file-spreadsheet',
              visible: true
            }
          ]
          // routerLink: ['payout/create']
        },
        {
          label: 'Books / Forms',
          routerLink: ['bookform'],
          visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'BOOKS.WRITE', 'BOOKS.READ', 'BOOKS.ADMIN']),
          // icon: 'fa-solid fa-book'
          items: [
            {
              label: 'Overview',
              routerLink: ['bookform'],
              icon: 'fa-duotone fa-book',
              visible: true
            },
            {
              label: 'Accounting',
              routerLink: ['admin/accounting'],
              icon: 'fa-duotone fa-file-spreadsheet',
              visible: true
            }
          ]
        },
        {
          label: 'Chart of Accounts',
          routerLink: ['account/chart-of-accounts'],
          visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'ACCOUNTS.WRITE', 'ACCOUNTS.READ', 'ACCOUNTS.ADMIN']),
          // icon: 'fa-solid fa-book'
          items: [
            {
              label: 'Overview',
              routerLink: ['account/chart-of-accounts'],
              icon: 'fa-duotone fa-list-ol',
              visible: true
            }
          ]
        },
        {
          label: 'User Accounts',
          visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'ADMACCT.ADMIN', 'ADMACCT.WRITE', 'ADMACCT.READ']),
          routerLink: ['admin/users'],
          items: [
            {
              label: 'Admin',
              routerLink: ['admin/users'],
              icon: 'fa-duotone fa-users',
              visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'ADMACCT.ADMIN', 'ADMACCT.WRITE', 'ADMACCT.READ'])
            },
            {
              label: 'Members',
              routerLink: ['admin/members'],
              icon: 'fa-duotone fa-screen-users',
              visible: true
            },
            {
              label: 'Member Modules',
              routerLink: ['/member-modules/overview'],
              icon: 'fa-duotone fa-duotone',
              visible: await this.permissionService.hasPermission(['ADMINISTRATOR',  'ROSTER.ADMIN']),
            },
          ]
          // routerLink: ['payout/create']
        },

      ];
      console.log(this.items);
      const isMember = await this.permissionService.hasPermission(['MEMBER']);
      const entityID = this.keycloakService.getKeycloakInstance().tokenParsed?.sub;
      this.apollo.watchQuery<Query>({
        query: CLIENT_ACCESS_QUERY,
        variables: {
          entityID
        }
      }).valueChanges.subscribe(({data, loading}) => {
        const clientAccess = data?.clientModules;
        this.items = [...this.items,
          {
            label: 'Member',
            visible: isMember,
            routerLink: ['admin/users'],
            items: [
              {
                label: 'Concerns',
                routerLink: ['/concerns'],
                icon: 'fa-duotone fa-comment-exclamation',
                visible: clientAccess?.some((ca: any) => ca.HR_MODULE?.MODULE_NAME === 'CONCERNS')
              },
              {
                label: 'Leaves',
                routerLink: ['leaves'],
                icon: 'fa-duotone fa-person-walking',
                visible: clientAccess?.some((ca: any) => ca.HR_MODULE?.MODULE_NAME === 'SOMA')
              }, // VISIBLE OF LEAVES MUST BE CHANGED SOON (ONLY USED AS A BANDAID SOLUTION)
              {

                label: 'SOMA',
                routerLink: ['soma'],
                icon: 'fa-duotone fa-file-invoice-dollar',
                visible: clientAccess?.some((ca: any) => ca.HR_MODULE?.MODULE_NAME === 'SOMA')
              },
            ]
            // routerLink: ['payout/create']
          },

        ];
        console.log(clientAccess);
      });
    });



    this.keycloakService.loadUserProfile().then(r => {
      this.appUser = r;
    });
    //   }
    // });

  }

  // apollo.watchQuery<Query>({
  //   query: checkRegistered
  // }).valueChanges.subscribe(({data, loading})=>{
  //   if(!data.isRegistered){
  //     router.navigate(['/registration']);
  //   }
  // });

  async ngOnInit(): Promise<void> {
  }

  async LogOut(): Promise<void> {
    await this.keycloakService.logout();
  }

  async ngAfterViewInit(): Promise<void> {

  }

  toggleSidebar(): void {
    this.sidebarState = !this.sidebarState;
  }

  navigateToLink(routerLink: any): void {
    this.router.navigate(routerLink).then(m => {
      this.toggleSidebar();
    });
  }
}
